export default function () {
  return ['iPad', 'iPhone', 'iPod'].includes(navigator.platform);
}
